// Only these exporters stack the texture over the flat color, the rest trace the text and drop it
const TEXTURE_EXPORT_FORMATS = ['png', 'jpg', 'pdf'];

export const exportFormatSupportsTexture = (exportFormat?: string) =>
    !!exportFormat && TEXTURE_EXPORT_FORMATS.includes(exportFormat);
